import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {SimpleGallery} from "../../SimpleGallery";
import {getProjectByPath} from "../../../db/projectStore";
import {Col, Row} from "react-bootstrap";
import {SponsorLogos} from "../../SponsorLogos";

const DatesBlock = ({ label, items }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className="dates-block">
      <p className="fs-5 mt-5">{label}</p>
      {items.map((item, index) => (
        <span key={index} className='d-block'>
          <strong>{item.date}</strong> {item.location}
        </span>
      ))}
    </div>
  );
};

export const ProjectDetailPage = () => {
  const { projectPath } = useParams()
  const project = getProjectByPath(projectPath)
  const [galleryData, setGalleryData] = useState([]);
  const [posterSrc, setPosterSrc] = useState(null);
  
  useEffect(() => {
    const loadGalleryData = async () => {
      try {
        // Dynamically import the JSON file based on the projectPath
        const data = (await import(`../../../images/${projectPath}/${projectPath}.json`)).default;
        const formattedData = data.map(image => ({
          src: require(`../../../images/${projectPath}/${image.src}`), // Dynamically require the image
          width: image.width,
          height: image.height,
        }));
        setGalleryData(formattedData);
      } catch (error) {
        console.error("Error loading gallery data:", error);
      }
    };
    
    loadGalleryData().catch(error => console.log(error));
  }, [projectPath]);

  useEffect(() => {
    if (project?.posterImage) {
      try {
        setPosterSrc(require(`../../../images/${projectPath}/${project.posterImage}`));
      } catch (error) {
        console.error("Error loading poster image:", error);
        setPosterSrc(null);
      }
    } else {
      setPosterSrc(null);
    }
  }, [projectPath, project?.posterImage]);

  const dateGroups = (project.dateGroups || []).filter(g => g.items && g.items.length > 0);
  const hasDates = dateGroups.length > 0;
  const hasCast = project.cast && project.cast.length > 0;

  const descriptionParagraphs = Array.isArray(project.description)
    ? project.description
    : (project.description || "").split(/\n+/).filter(Boolean);

  const descriptionFooterParagraphs = Array.isArray(project.descriptionFooter)
    ? project.descriptionFooter
    : (project.descriptionFooter ? [project.descriptionFooter] : []);

  return (
    <div>
      <h1>{project.title}</h1>
      <p> {project.caption}</p>
      <Row>
        <Col xs={12} md={6} className="fs-4 fw-light">
          {descriptionParagraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
          {descriptionFooterParagraphs.map((paragraph, index) => (
            <p key={`footer-${index}`} className="fs-6 fst-italic">{paragraph}</p>
          ))}
        </Col>
        <Col xs={12} md={6}>
          {project.youtubeTrailer ? (
            <div className="ratio ratio-16x9">
              <iframe src={project.youtubeTrailer}
                      title="YouTube video player" frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen></iframe>
            </div>
          ) : posterSrc ? (
            <img src={posterSrc} alt={project.title}
                 style={{ width: '100%', height: 'auto', display: 'block' }} />
          ) : null}
        </Col>
      </Row>
      {(hasCast || hasDates) &&
        <Row>
          {hasCast &&
            <Col xs={12} lg={7} className="mb-5">
              <p className='fs-5 mt-5'>Cast & Credits</p>
              <p className='fs-5 mt-5'>
                {project.cast.map((item, index) => (
                  <span key={index} className='d-block'>{item.role}:<strong> {item.names} </strong></span>
                ))}
              </p>
            </Col>
          }
          {hasDates &&
            <Col xs={12} lg={hasCast ? 5 : 12} className="mb-5">
              {dateGroups.map((group, index) => (
                <DatesBlock key={index} label={group.label} items={group.items} />
              ))}
            </Col>
          }
        </Row>
      }
      <SimpleGallery images={galleryData}/>
      <SponsorLogos logos={project.logos} />
    </div>
  )
}